/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { PointDtoModel } from '@well/address-management-domain-model';
import { LocationDtoModel } from '@well/delivery-libs/location-management/domain';

export class LocationMapper {

  static mapPlaceToLocation(place: google.maps.places.PlaceResult): LocationDtoModel {
    const pointDTO = place.geometry?.location
      ? PointDtoModel.asPointDto(place.geometry.location)
      : undefined;

    const cityObject = place.address_components?.find((component) => component.types.indexOf('locality') >= 0);
    const countryObject = place.address_components?.find((component) => component.types.indexOf('country') >= 0);

    const city = cityObject ? cityObject.long_name : null;
    const country = countryObject ? countryObject.short_name : null;
    const name = city + ',' + country;
    return {
      uuid: undefined,
      name: name,
      city: city,
      country: country,
      pointDTO: pointDTO,
    };
  }
}
